import { createSlice } from '@reduxjs/toolkit';
import { baseOnboardingUrl } from './hooks';

const initialState = {
  // Modal-specific state
  baseUrl: baseOnboardingUrl,
  
  // Stage checklist data
  stageCheckList: {
    "registration_link": {
      "workflows": ["voip", "non-voip", "dso"],
      "description": "send the registration link in advance of the kickoff"
    }
  },
  
  // Loading and error states
  loading: false,
  error: null,
  
  // Success state
  success: false
};

const kickoffSlice = createSlice({
  name: 'kickoff',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
});

export const {
  clearError,
  clearSuccess,
  setLoading
} = kickoffSlice.actions;

// Selectors
export const selectBaseUrl = (state) => state.kickoff.baseUrl;
export const selectStageCheckList = (state) => state.kickoff.stageCheckList;
export const selectLoading = (state) => state.kickoff.loading;
export const selectError = (state) => state.kickoff.error;
export const selectSuccess = (state) => state.kickoff.success;

export default kickoffSlice.reducer;
